import { createAsyncThunk } from '@reduxjs/toolkit';
import { RetrieveMessageArg, retrieveDirectRoomMessages } from './messages-slice-helper';

export const checkForChanges = createAsyncThunk(
    'directMessages/checkForChanges',
    async (arg: RetrieveMessageArg, dispatch: any) =>
        await retrieveDirectRoomMessages(arg, dispatch)
);
